import { createReducer } from "sc/helpers/reducer";
import {
  USER_PAGE_LOADED,
  USER_ADD_REQUEST,
  USER_USERNAME_CHANGE_REQUEST,
  USER_PASSWORD_CHANGE_REQUEST,
  USER_ENABLE_REQUEST,
  USER_DISABLE_REQUEST,
  USER_ADD_ERROR,
  USER_USERNAME_CHANGE_ERROR,
  USER_PASSWORD_CHANGE_ERROR,
  USER_ENABLE_ERROR,
  USER_DISABLE_ERROR,
  USER_USERNAME_CHANGED,
  USER_PASSWORD_CHANGED,
  USER_ENABLED,
  USER_DISABLED,
} from "../actions/users";
import { LOCATION_CHANGE } from "react-router-redux/reducer";

export default createReducer(null, {
  [LOCATION_CHANGE]: (state, action) => {
    const pathname = action.payload.pathname;
    const pathnameComponents = pathname.split("/");
    const lastComponent = pathnameComponents[pathnameComponents.length - 1];
    if (state !== null && lastComponent === state.username) {
      // This is a history replace caused by a username change.
      return state;
    }
    // This is a new page load
    return null;
  },
  [USER_PAGE_LOADED]: (state, action) =>
    Object.assign(
      {},
      {
        ...action.payload.user,
        saveUserDataInProgress: false,
        changeUsernameInProgress: false,
        changePasswordInProgress: false,
        enableInProgress: false,
        disableInProgress: false,
        saveUserDataError: "",
        changeUsernameError: "",
        changePasswordError: "",
        enableError: "",
        disableError: "",
      },
    ),
  [USER_ADD_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      saveUserDataInProgress: true,
      saveUserDataError: "",
    }),
  [USER_USERNAME_CHANGE_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      changeUsernameInProgress: true,
      changeUsernameError: "",
    }),
  [USER_PASSWORD_CHANGE_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      changePasswordInProgress: true,
      changePasswordError: "",
    }),
  [USER_ENABLE_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      enableInProgress: true,
      enableError: "",
    }),
  [USER_DISABLE_REQUEST]: (state, action) =>
    Object.assign({}, state, {
      disableInProgress: true,
      disableError: "",
    }),
  [USER_ADD_ERROR]: (state, action) =>
    Object.assign({}, state, {
      saveUserDataInProgress: false,
      saveUserDataError: action.payload.message,
    }),
  [USER_USERNAME_CHANGE_ERROR]: (state, action) =>
    Object.assign({}, state, {
      changeUsernameInProgress: false,
      changeUsernameError: action.payload.message,
    }),
  [USER_PASSWORD_CHANGE_ERROR]: (state, action) =>
    Object.assign({}, state, {
      changePasswordInProgress: false,
      changePasswordError: action.payload.message,
    }),
  [USER_ENABLE_ERROR]: (state, action) =>
    Object.assign({}, state, {
      enableInProgress: false,
      enableError: action.payload.message,
    }),
  [USER_DISABLE_ERROR]: (state, action) =>
    Object.assign({}, state, {
      disableInProgress: false,
      disableError: action.payload.message,
    }),
  [USER_USERNAME_CHANGED]: (state, action) =>
    Object.assign({}, state, {
      username: action.payload.username,
      changeUsernameInProgress: false,
      changeUsernameError: "",
    }),
  [USER_PASSWORD_CHANGED]: (state, action) =>
    Object.assign({}, state, {
      changePasswordInProgress: false,
      changePasswordError: "",
    }),
  [USER_ENABLED]: (state, action) =>
    Object.assign({}, state, {
      enabled: true,
      enableInProgress: false,
      enableError: "",
    }),
  [USER_DISABLED]: (state, action) =>
    Object.assign({}, state, {
      enabled: false,
      disableInProgress: false,
      disableError: "",
    }),
});



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/reducers/edited-user-reducer.js